export default __webpack_public_path__ + "static/media/filandia.5f049c31.png";